module.exports = __webpack_public_path__ + "static/img/1.a4b0ff5.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/6/zh/1.png
// module id = jUIm
// module chunks = 0